import { ModalHeader, SimpleModal, Space, Typography } from '../..'
import Icon from '../../atoms/Icon/Icon'
import IconButton from '../../molecules/iconButton/iconButton'

export type ConfirmationModalProps = {
  description: string
  onClose: () => void
  onConfirm: () => void
  title: string
}

export const ConfirmationModal = ({
  description,
  onClose,
  onConfirm,
  title
}: ConfirmationModalProps) => (
  <SimpleModal>
    <ModalHeader onClickClose={onClose}>{title}</ModalHeader>
    <Space p={6}>
      <Space mb={6}>
        <Typography fontSize={13} variant="b3">
          {description}
        </Typography>
      </Space>
      <Space isinlineblock mr={2}>
        <IconButton
          disabled={false}
          icon={<Icon name="check" size="medium" />}
          iconPosition="left"
          operationType="progress"
          text="Yes"
          onClick={onConfirm}
        />
      </Space>
      <Space isinlineblock ml={2}>
        <IconButton
          disabled={false}
          icon={<Icon name="circleX" size="medium" />}
          iconPosition="left"
          operationType="cancel"
          text="No"
          onClick={onClose}
        />
      </Space>
    </Space>
  </SimpleModal>
)
